export default __webpack_public_path__ + "static/media/chevron left.8f1a6990.svg";